import DateField from '../../../date-field';
import { FilterComponentProps } from '../../types';

export function DateFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;

  return <DateField 
    id={filter.name.toString()} 
    label={filter.label} 
    value={filter.value as string}   
    onChange={(value) => {
        onChange({
          ...filter,
          value
        });
      }}
  />;
}